import {Injectable} from '@angular/core';
import {Options} from "highcharts";

@Injectable({
  providedIn: 'root'
})
export class SolidgaugeChartService {

  public static getOptions(y_value, color, backgroundColor) {
    let options: Options = {
      chart: {
        type: 'solidgauge',
        reflow: true
      },
      legend: {
        enabled: false
      },
      credits: {enabled: false},
      tooltip: {enabled: false},
      title: {
        text: ''
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [{ // Track for Move
          outerRadius: '112%',
          innerRadius: '0%',
          backgroundColor: backgroundColor,
          borderWidth: 0
        }]
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: []
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: 'round',
          stickyTracking: false,
        }
      },
      series: [{
        name: 'Move',
        type: "solidgauge",
        data: [{
          color: color,
          radius: '112%',
          innerRadius: '70%',
          y: y_value
        }]
      }]
    };
    return options;
  }

  public static getDeprecatedOptionsDepartment(y_value, color, backgroundColor) {
    let options: Options = {
      chart: {
        type: 'solidgauge',
        reflow: true,
      },
      legend: {
        enabled: false
      },
      credits: {enabled: false},
      tooltip: {enabled: false},
      title: {
        text: ''
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [{ // Track for Move
          outerRadius: '112%',
          innerRadius: '0%',
          backgroundColor: backgroundColor,
          borderWidth: 0
        }]
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: []
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: 'round',
          stickyTracking: false,
        }
      },
      series: [{
        name: 'Move',
        type: "solidgauge",
        data: [{
          color: color,
          radius: '112%',
          innerRadius: '80%',
          y: y_value
        }]
      }]
    };
    return options;
  }

  public static getOptionsDepartment(y_value, color, backgroundColor) {
    let options: Options = {
      chart: {
        type: 'solidgauge',
        reflow: true,
        width: 32,
        height: 32,
        margin: 0,
      },
      legend: {
        enabled: false
      },
      credits: {enabled: false},
      tooltip: {enabled: false},
      title: {
        text: ''
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        size: '100%',
        background: [{ // Track for Move
          outerRadius: '100%',
          innerRadius: '0%',
          backgroundColor: backgroundColor,
          borderWidth: 0
        }]
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: []
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: false
          },
          linecap: 'round',
          stickyTracking: false,
        }
      },
      series: [{
        name: 'Move',
        type: "solidgauge",
        data: [{
          color: color,
          radius: '100%',
          innerRadius: '80%',
          y: y_value
        }]
      }]
    };
    return options;
  }
}
